exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3QbaGeIZsZTF1oKKmGdW2N{display:inline;overflow:hidden;text-overflow:ellipsis;vertical-align:top}._3ONrQ132jIpnG2j49wpR-O{font-weight:600}", ""]);
// Exports
exports.locals = {
	"recipientContent": "_3QbaGeIZsZTF1oKKmGdW2N",
	"groupOrDl": "_3ONrQ132jIpnG2j49wpR-O"
};